import React, { useState } from "react";
import { track } from "../../../analytics";
import "./HomeIptv.scss";
import HomeIptvList from "./HomeIptvList/HomeIptvList";
import HomeIptvCard from "./HomeIptvCard/HomeIptvCard";
import Form from "../../General/Form/Form";

/*
  Слева баннер активной категории, справа — список категорий и кнопка заявки.
  Категория переключается кликом и стрелками; на мобиле тот же список
  становится горизонтальной лентой чипов.
*/
const HomeIptv = ({ IptvCannel, activeTitleIptv }) => {
  const [active, setActive] = useState(0);
  const [activate, setActivate] = useState(false);

  const count = IptvCannel?.length || 0;

  const onListKeyDown = (event) => {
    const step = event.key === "ArrowRight" || event.key === "ArrowDown" ? 1
      : event.key === "ArrowLeft" || event.key === "ArrowUp" ? -1 : 0;
    if (!step || !count) return;
    event.preventDefault();
    const next = (active + step + count) % count;
    track("iptv_category", { category: String(IptvCannel?.[next]?.title || next) });
    setActive(next);
    const buttons = event.currentTarget.querySelectorAll("button");
    if (buttons[next]) buttons[next].focus();
  };

  return (
    <div className="homeIptv_container" id="iptv">
      <div className="homeIptv_block">
        <div className="homeIptv_title">
          <h1>Интернет и IPTV от NETS</h1>
        </div>

        <div className="homeIptv_grid">
          <HomeIptvCard
            activeTitleIptv={activeTitleIptv}
            categories={IptvCannel || []}
            index={active}
          />

          <div className="homeIptvPanel_block">
            <div className="homeIptvPanel_list" onKeyDown={onListKeyDown}>
              {IptvCannel?.map((e, index) => (
                <HomeIptvList
                  key={e.id}
                  title={e.title}
                  active={active === index}
                  onSelect={() => {
                    track("iptv_category", { category: String(e?.title || index) });
                    setActive(index);
                  }}
                />
              ))}
            </div>
            <button
              type="button"
              className="homeIptvPanel_cta"
              onClick={() => setActivate(true)}
            >
              Подключить IPTV
            </button>
          </div>
        </div>
      </div>

      {activate && (
        <div className="form_container">
          <div className="form_block">
            <Form show={true} setShowModal={setActivate} id={685} endpoint={'add_deal'} />
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeIptv;
